import { useContext, useState } from "react";
import { TutorialContext } from "contexts/TutorialContext";
import TutorialVideoModal from "components/global/TutorialVideoModal";
import VideoModal from "views/home/VideoModal";

const AppWideVideoTutorial = () => {
  const { hasSeenVideo } = useContext(TutorialContext);
  const [showVideo, setShowVideo] = useState(null);

  return (
    <>
      {hasSeenVideo.tutorials_drawer && (
        <VideoModal setShowVideo={setShowVideo} />
      )}

      {showVideo && (
        <TutorialVideoModal
          videoData={showVideo}
          closeModal={() => setShowVideo(null)}
        />
      )}
    </>
  );
};

export default AppWideVideoTutorial;
